import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface SeparatorProps extends HTMLAttributes<HTMLDivElement> {
    orientation?: 'horizontal' | 'vertical';
    decorative?: boolean;
}

const Separator = forwardRef<HTMLDivElement, SeparatorProps>(
    ({ className, orientation = 'horizontal', ...props }, ref) => (
        <div
            ref={ref}
            role="separator"
            className={cn(
                'shrink-0 bg-border',
                orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
                className
            )}
            {...props}
        />
    )
);
Separator.displayName = 'Separator';

export { Separator };
